import { Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AuthenticationService } from './services/authentication/authentication.service';
import { ECompany } from './enums';
import { Environment } from './types';
import { ENVIRONMENT } from './constants';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  isUserLogged: boolean = false;
  subscriptions$ = new Subscription();
  favIcon: HTMLLinkElement;
  @ViewChild(MatSidenav) sidenav!: MatSidenav;

  constructor(
    private titleService: Title,
    private authService: AuthenticationService,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {
    this.subscriptions$.add(
      this.authService.authNavStatus$.subscribe((status) => {
        this.isUserLogged = status;
      })
    );
    this.favIcon = document.querySelector('#favicon')!;
    if (this.environment.company === ECompany.KM_DO_BRASIL) {
      this.titleService.setTitle(this.environment.companyName);
      this.favIcon.href = '/assets/images/kmDoBrasil/logo/icon.png';
      document.body.classList.remove(ECompany.APNETWORKS);
      document.body.classList.add(ECompany.KM_DO_BRASIL);
      document.head.appendChild(this.favIcon);
      return;
    }

    this.titleService.setTitle(this.environment.companyName);
    this.favIcon.href = '/assets/images/apnetworks/logo/icon.png';
    document.body.classList.remove(ECompany.KM_DO_BRASIL);
    document.body.classList.add(ECompany.APNETWORKS);
    document.head.appendChild(this.favIcon);
  }

  toggleSidebar() {
    this.sidenav.toggle();
  }

  ngOnDestroy() {
    this.subscriptions$?.unsubscribe();
  }
}
